// src/App.js
import React, { useEffect } from "react";
import { HashRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import api from "./api/api.js";
import PrivateRoute from "./Components/PrivateRoute";

import NavBar from "./Components/NavBar";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import AdminDashboard from "./Pages/AdminDashboard";
import BusRoutes from "./Pages/BusRoutes";
import EmployeeDashboard from "./Pages/EmployeeDashboard";
import PurchaseConfirmation from "./Pages/PurchaseConfirmation";
import Invoice from "./Pages/Invoice";
import UserProfile from "./Pages/UserProfile";
import CompletarRegistro from './Pages/CompletarRegistro';
import PaymentConfirmation from "./Pages/PaymentConfirmation";
import ForgotPassword from "./Pages/ForgotPassword";
import RestablecerContrasena from "./Pages/RestablecerContrasena";
import VerificarCorreo from "./Pages/VerificarCorreo";
import CourseManagement from "./Pages/CourseManagement";

const HIDDEN_NAVBAR_ROUTES = ['/admin', '/employee'];

function ConditionalNavBar() {
  const location = useLocation();
  if (HIDDEN_NAVBAR_ROUTES.includes(location.pathname)) return null;
  return <NavBar />;
}

function App() {
  useEffect(() => {
    // Mantener viva la sesión para usuarios autenticados mediante ping al backend.
    // El token real viaja en cookie HttpOnly, no en localStorage.
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    const role = currentUser.role;

    if (role === "admin" || role === "employee" || role === "client") {
      const intervalId = setInterval(() => {
        api.get("/me").catch(() => {});
      }, 30_000);

      return () => clearInterval(intervalId);
    }
  }, []);

  return (
    <Router>
      <ConditionalNavBar />
      <Routes>
        {/* Rutas públicas */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/busroutes" element={<BusRoutes />} />
        <Route path="/confirmacion" element={<PurchaseConfirmation />} />
        <Route path="/completar-registro" element={<CompletarRegistro />} />

        {/* Recuperar contraseña */}
        <Route path="/restablecer-contrasena" element={<ForgotPassword />} />
        <Route path="/restablecer" element={<RestablecerContrasena />} />

        {/* Verificar correo */}
        <Route path="/verificar-correo" element={<VerificarCorreo />} />

        {/* Rutas solo para usuarios autenticados */}
        <Route path="/PerfilUsuario" element={<PrivateRoute element={<UserProfile />} />} />
        <Route path="/payment/:ticketId" element={<PrivateRoute element={<PaymentConfirmation />} />} />
        <Route path="/factura" element={<PrivateRoute element={<Invoice />} />} />

        {/* Rutas privadas por rol */}
        <Route path="/admin" element={<PrivateRoute element={<AdminDashboard />} allowedRoles={['admin']} />} />
        <Route path="/employee" element={<PrivateRoute element={<EmployeeDashboard />} allowedRoles={['admin', 'empleado', 'employee']} />} />
        <Route path="/course-management" element={<PrivateRoute element={<CourseManagement />} allowedRoles={['admin', 'empleado', 'employee']} />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
